<template>
  <div class="feng-tuoyuan-trace">
    <div class="trace-header">
      <img class="trace-logo" src="/static/images/fty/logo.png" alt="丰驼源 logo">
    </div>

    <div class="trace-card">
      <div class="trace-info">
        <div class="trace-info-row">
          <div class="trace-info-label">产品名称：</div>
          <div class="trace-info-value">{{ productName }}</div>
        </div>
        <div class="trace-info-row">
          <div class="trace-info-label">产品型号：</div>
          <div class="trace-info-value">{{ productCode }}</div>
        </div>
        <div class="trace-info-row">
          <div class="trace-info-label">生产批次：</div>
          <div class="trace-info-value">{{ productBatch }}</div>
        </div>
        <div class="trace-info-row trace-info-row-address">
          <div class="trace-info-label">出库仓库：</div>
          <div class="trace-info-value">{{ warehouse }}</div>
        </div>
      </div>

      <div class="trace-title">丰驼源乳业</div>

      <div class="trace-timeline">
        <div
          v-for="(item, index) in timelineList"
          :key="index"
          class="trace-timeline-item"
        >
          <div class="trace-timeline-axis">
            <div class="trace-timeline-dot"></div>
            <div
              v-if="index !== timelineList.length - 1"
              class="trace-timeline-line"
            ></div>
          </div>
          <div class="trace-timeline-content">
            <div class="trace-timeline-title">{{ item.title }}</div>
            <div class="trace-timeline-desc">{{ item.desc }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getInfoByCode } from '../../api/api'

export default {
  name: 'FengTuoYuanTrace',
  data() {
    return {
      rawCode: '',
      codeInfoResponse: null,
      codeInfoData: null,
      productName: '',
      productCode: '',
      productBatch: '',
      warehouse: '',
      timelineList: [
        {
          title: '关于丰驼源',
          desc: '全疆唯一集有机饲草种植、有机牧养殖到科技研发、生产销售于一体的骆驼全产业链。'
        },
        {
          title: '黄金奶源',
          desc: '东经86.030338，北纬46.505807黄金奶源带，自有300万亩有机荒漠草场，7万峰珍稀双峰驼自然散养，生态环境和自然条件造就顶级奶源。'
        },
        {
          title: '双重锁鲜工艺',
          desc: '首家创造性的将“低温巴氏杀菌”与“微米级陶瓷膜过滤”双重锁鲜工艺应用在驼奶领域，最大程度保留驼乳中天然活性营养。'
        },
        {
          title: '双有机认证',
          desc: '有机产品认证与有机养殖认证，双有机保障，让每一罐驼奶都经得起最严格的品质检验。'
        },
        {
          title: '无菌灌装技术',
          desc: '选用多层复合结构的利乐钻包装，全程无菌灌装+密闭隔菌，从生产端完全杜绝污染。让自然的温度，从牧场原封不动地抵达每一个生命。'
        }
      ]
    }
  },
  computed: {
    queryCode() {
      return String(this.rawCode || '').slice(0, 16)
    }
  },
  mounted() {
    this.rawCode = this.$route.query.c || ''
    this.loadCodeInfo()
  },
  methods: {
    async loadCodeInfo() {
      if (!this.queryCode) {
        return
      }
      try {
        const res = await getInfoByCode(this.queryCode)
        const data = res && res.data ? res.data : null
        this.codeInfoResponse = data
        this.codeInfoData = data && data.data ? data.data : null
        if (this.codeInfoData) {
          this.productName = this.codeInfoData.productName || ''
          this.productCode = this.codeInfoData.productNo || ''
          this.productBatch = this.codeInfoData.f10 || ''
          this.warehouse = this.codeInfoData.f11 || ''
        } else {
          this.productName = ''
          this.productCode = ''
          this.productBatch = ''
          this.warehouse = ''
        }
        console.log('FengTuoYuan trace codeInfo result:', data)
      } catch (error) {
        this.codeInfoResponse = null
        this.codeInfoData = null
        this.productName = ''
        this.productCode = ''
        this.productBatch = ''
        this.warehouse = ''
        console.error('丰驼源溯源码信息查询失败:', error)
      }
    }
  }
}
</script>

<style scoped>
.feng-tuoyuan-trace {
  min-height: 100vh;
  padding: clamp(10px, 2.8vw, 18px) clamp(14px, 3.8vw, 22px) calc(clamp(18px, 4.2vw, 24px) + env(safe-area-inset-bottom));
  box-sizing: border-box;
  background: rgb(76, 189, 200);
  overflow-y: auto;
}

.trace-header {
  display: flex;
  justify-content: center;
  margin-bottom: clamp(14px, 3.8vw, 22px);
}

.trace-logo {
  display: block;
  width: clamp(108px, 27.9vw, 153px);
  height: auto;
}

.trace-card {
  width: 100%;
  max-width: 640px;
  margin: 0 auto;
  padding: clamp(22px, 5.2vw, 30px) clamp(16px, 4.6vw, 28px) clamp(24px, 5.5vw, 34px);
  box-sizing: border-box;
  border-radius: clamp(22px, 5.8vw, 34px);
  background: rgb(249, 250, 251);
}

.trace-info {
  width: 100%;
}

.trace-info-row {
  display: flex;
  align-items: flex-start;
  margin-bottom: clamp(12px, 3vw, 18px);
  font-size: clamp(11px, 3vw, 13px);
  line-height: 1.5;
  color: #444444;
}

.trace-info-row:last-child {
  margin-bottom: 0;
}

.trace-info-label {
  flex: 0 0 auto;
  width: clamp(72px, 17vw, 84px);
  font-size: inherit;
  line-height: inherit;
  font-weight: 400;
}

.trace-info-value {
  flex: 1;
  font-size: inherit;
  line-height: inherit;
  font-weight: 400;
  word-break: break-word;
}

.trace-title {
  margin-top: clamp(24px, 5.6vw, 34px);
  text-align: center;
  font-size: clamp(22px, 6vw, 30px);
  line-height: 1.2;
  font-weight: 700;
  color: #333333;
}

.trace-timeline {
  margin-top: clamp(22px, 5.8vw, 34px);
}

.trace-timeline-item {
  display: flex;
  align-items: stretch;
}

.trace-timeline-axis {
  width: 28px;
  display: flex;
  flex-direction: column;
  align-items: center;
  flex-shrink: 0;
}

.trace-timeline-dot {
  width: 14px;
  height: 14px;
  border: 3px solid rgb(76, 189, 200);
  border-radius: 50%;
  background: rgb(249, 250, 251);
}

.trace-timeline-line {
  flex: 1;
  width: 3px;
  margin: 4px 0;
  background: rgb(76, 189, 200);
}

.trace-timeline-content {
  flex: 1;
  padding-left: clamp(10px, 2.8vw, 16px);
  padding-bottom: clamp(22px, 5.8vw, 30px);
}

.trace-timeline-title {
  margin-bottom: clamp(8px, 2vw, 10px);
  font-size: clamp(15px, 4vw, 18px);
  line-height: 1.3;
  font-weight: 700;
  color: rgb(76, 189, 200);
}

.trace-timeline-desc {
  font-size: clamp(12px, 3.2vw, 14px);
  line-height: 1.5;
  color: #555555;
}

@media (max-height: 568px) {
  .feng-tuoyuan-trace {
    padding-top: 10px;
    padding-left: 10px;
    padding-right: 10px;
  }

  .trace-header {
    margin-bottom: 10px;
  }

  .trace-logo {
    width: 118px;
  }

  .trace-card {
    padding: 18px 14px 22px;
    border-radius: 20px;
  }

  .trace-info-row {
    margin-bottom: 10px;
    font-size: 13px;
  }

  .trace-info-label {
    width: 70px;
  }

  .trace-title {
    margin-top: 18px;
    font-size: 24px;
  }

  .trace-timeline {
    margin-top: 20px;
  }

  .trace-timeline-content {
    padding-left: 10px;
    padding-bottom: 20px;
  }

  .trace-timeline-title {
    font-size: 16px;
  }

  .trace-timeline-desc {
    font-size: 12px;
    line-height: 1.5;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/FengTuoYuan/Trace.vue